import React, { Component } from 'react'
import * as XLSX from 'xlsx'
import { Link } from 'react-router-dom'
import ElementsDataService from '../../api/entitiesDataServices/ElementsDataService.js'
import AuthenticationService from '../general/AuthenticationService.js'

const PAGE_SIZE = 25

/* ───────── sessionStorage persistence ───────── */
const SOC_STORAGE_KEY = 'soc_filters_v2'

function saveFilters(state) {
    try {
        sessionStorage.setItem(SOC_STORAGE_KEY, JSON.stringify({
            busqueda:         state.busqueda         || '',
            statusContable:   state.statusContable   || '',
            statusLegal:      state.statusLegal      || '',
            controlDom:       state.controlDom       || '',
            tipoDom:          state.tipoDom          || '',
            busquedaDomicilio:state.busquedaDomicilio|| '',
            currentPage:      state.currentPage      || 1,
            sortKey:          state.sortKey          || 'razonSocial',
            sortAsc:          state.sortAsc !== false,
            clienteIds:       (state.clientes || []).map(c => c.id),
        }))
    } catch(e) {}
}

function loadFilters() {
    try {
        const raw = sessionStorage.getItem(SOC_STORAGE_KEY)
        if (raw) return JSON.parse(raw)
    } catch(e) {}
    return null
}

function clearFilters() {
    try { sessionStorage.removeItem(SOC_STORAGE_KEY) } catch(e) {}
}

/* ═══════════════════════ COMPONENT ═══════════════════════ */

class SociedadComponent extends Component {
    constructor(props) {
        super(props)

        const saved = loadFilters()

        this.state = {
            elements: [],
            allClientes: [],
            clientes: [],
            statusLegal:         saved?.statusLegal        || '',
            statusContable:      saved?.statusContable     || '',
            busqueda:            saved?.busqueda           || '',
            busquedaDomicilio:   saved?.busquedaDomicilio  || '',
            controlDom:          saved?.controlDom         || '',
            tipoDom:             saved?.tipoDom            || '',
            loading: true,
            currentPage:         saved?.currentPage        || 1,
            sortKey:             saved?.sortKey            || 'razonSocial',
            sortAsc:             saved?.sortAsc            !== false,
            _restoredClienteIds: saved?.clienteIds         || [],
        }
        this.sortBy = this.sortBy.bind(this)
        this.descargarExcel = this.descargarExcel.bind(this)
    }

    componentDidMount() {
        if (!AuthenticationService.haveAuthorization("READ_SOCIEDADES")) {
            alert("Usuario no autorizado")
            return
        }

        const { busqueda, sortKey, sortAsc } = this.state

        const fetchSociedades = busqueda && busqueda.length > 2
            ? ElementsDataService.retrieveSearch(busqueda, "sociedades")
            : ElementsDataService.retrieveAllElements("sociedades")

        fetchSociedades
            .then(r => {
                this.setState({ elements: this.doSort(sortKey, sortAsc, r.data) })
                return ElementsDataService.retrieveAllElements("clientes")
            })
            .then(r => {
                const allClientes = r.data
                // Restore selected clientes from URL
                const restoredClientes = (this.state._restoredClienteIds || [])
                    .map(id => allClientes.find(c => c.id === id))
                    .filter(Boolean)
                this.setState({
                    allClientes,
                    clientes: restoredClientes,
                    loading: false,
                })
            })
            .catch(() => this.setState({ loading: false }))
    }

    /* ── Persist filters to sessionStorage ── */
    syncUrl(stateOverrides = {}) {
        const merged = { ...this.state, ...stateOverrides }
        saveFilters(merged)
    }

    /* ── State setter that also syncs URL ── */
    setFilterState(updates, callback) {
        this.setState(updates, () => {
            this.syncUrl()
            if (callback) callback()
        })
    }

    doSort(key, asc, arr) {
        return [...arr].sort((a, b) => {
            let va, vb
            if (key === 'clientes') {
                va = a.clientes?.[0]?.nombreCliente || ''
                vb = b.clientes?.[0]?.nombreCliente || ''
            } else {
                va = (a[key] || '').toString().trim().toUpperCase()
                vb = (b[key] || '').toString().trim().toUpperCase()
            }
            if (va < vb) return asc ? -1 : 1
            if (va > vb) return asc ? 1 : -1
            return 0
        })
    }

    sortBy(key) {
        const asc = this.state.sortKey === key ? !this.state.sortAsc : true
        this.setFilterState({
            elements: this.doSort(key, asc, this.state.elements),
            sortKey: key, sortAsc: asc, currentPage: 1
        })
    }

    onBusqueda(value) {
        const val = value.toUpperCase()
        this.setFilterState({ busqueda: val, currentPage: 1 })
        if (val.length > 2) {
            ElementsDataService.retrieveSearch(val, "sociedades")
                .then(r => this.setState({ elements: r.data }))
        } else if (val.length === 0) {
            ElementsDataService.retrieveAllElements("sociedades")
                .then(r => this.setState({ elements: this.doSort(this.state.sortKey, this.state.sortAsc, r.data) }))
        }
    }

    getFiltered() {
        const { elements, statusContable, statusLegal, clientes, controlDom, tipoDom, busquedaDomicilio } = this.state
        const clientesIds = clientes.map(c => c.id)
        const busqDom = busquedaDomicilio.trim().toUpperCase()
        return (elements || []).filter(s => {
            if (statusContable && s.statusContabilidad !== statusContable) return false
            if (statusLegal && (s.statusLegal || '').toUpperCase() !== statusLegal) return false
            if (clientesIds.length && !s.clientes?.some(c => clientesIds.includes(c.id))) return false
            if (controlDom && !s.domicilios?.some(d => (d.control || '').toUpperCase() === controlDom)) return false
            if (tipoDom && !s.domicilios?.some(d => (d.tipo || '').toUpperCase() === tipoDom)) return false
            if (busqDom && !s.domicilios?.some(d =>
                [d.calle, d.colonia, d.municipio, d.estado, d.cp]
                    .some(v => v && v.toUpperCase().includes(busqDom))
            )) return false
            return true
        })
    }

    descargarExcel(filtered) {
        const data = filtered.map((e, i) => ({
            'N°':                       i + 1,
            'Proyecto':                 e.clientes?.map(c => c.nombreCliente).join(', ') || '',
            'Razón Social':             e.razonSocial || '',
            'RFC':                      e.rfc || '',
            'Responsable Contabilidad': e.responsableContable || '',
            'Auxiliar Contable':        e.auxiliarContable || '',
            'Estatus Contable':         e.statusContabilidad || '',
            'Estatus Legal':            (e.statusLegal || '').toUpperCase(),
            'Domicilio Actual':         (e.domicilios || []).map(d =>
                [d.calle, d.numeroExt, d.colonia, d.municipio, d.estado].filter(Boolean).join(', ')
            ).join(' | ') || '',
        }))
        const ws = XLSX.utils.json_to_sheet(data)
        ws['!cols'] = [
            { wch:4 }, { wch:28 }, { wch:36 }, { wch:16 },
            { wch:24 }, { wch:22 }, { wch:18 }, { wch:18 }, { wch:40 },
        ]
        const wb = XLSX.utils.book_new()
        XLSX.utils.book_append_sheet(wb, ws, 'Sociedades')
        XLSX.writeFile(wb, `Sociedades_${new Date().toISOString().slice(0,10)}.xlsx`)
    }

    render() {
        const { allClientes, clientes, statusContable, statusLegal, busqueda, busquedaDomicilio, controlDom, tipoDom, loading, currentPage, sortKey, sortAsc } = this.state
        const filtered = this.getFiltered()
        const totalPages = Math.max(1, Math.ceil(filtered.length / PAGE_SIZE))
        const page = Math.min(currentPage, totalPages)
        const pageData = filtered.slice((page - 1) * PAGE_SIZE, page * PAGE_SIZE)

        const SortIcon = ({ k }) => {
            if (sortKey !== k) return <span style={{ color: '#cbd5e1', marginLeft: 4 }}>↕</span>
            return <span style={{ color: '#3b82f6', marginLeft: 4 }}>{sortAsc ? '↑' : '↓'}</span>
        }

        const statusContableOpts = ['ACTIVA','SIN UTILIZAR','INACTIVA','PROCESO LIQUIDACION','LIQUIDADA','PROCESO SUSPENSION','SUSPENDIDA','VENDIDA','DEVUELTA','NO REVISION']
        const statusLegalOpts = ['ACTIVA','INACTIVA','SUSP>L...','LIQX','P.E.','REACT','N/A']

        const hasFilters = statusContable || statusLegal || clientes.length || busqueda || controlDom || tipoDom || busquedaDomicilio

        return (
            <div style={styles.root}>
                <style>{`
                    @import url('https://fonts.googleapis.com/css2?family=Inter:wght@400;500;600;700&display=swap');
                    .soc-root * { font-family: 'Inter', sans-serif; box-sizing: border-box; }
                    .soc-input {
                        width: 100%; padding: 9px 14px;
                        background: white; border: 1px solid #e2e8f0;
                        border-radius: 10px; font-size: 0.84rem; color: #334155;
                        outline: none; transition: all 0.2s; font-family: 'Inter', sans-serif;
                    }
                    .soc-input:focus { border-color: #3b82f6; box-shadow: 0 0 0 3px rgba(59,130,246,0.1); }
                    .soc-select {
                        width: 100%; padding: 9px 14px;
                        background: white; border: 1px solid #e2e8f0;
                        border-radius: 10px; font-size: 0.84rem; color: #334155;
                        outline: none; cursor: pointer; transition: all 0.2s; font-family: 'Inter', sans-serif;
                    }
                    .soc-select:focus { border-color: #3b82f6; box-shadow: 0 0 0 3px rgba(59,130,246,0.1); }
                    .soc-th {
                        padding: 10px 14px; text-align: left;
                        font-size: 0.7rem; font-weight: 700; color: #64748b;
                        letter-spacing: 0.8px; text-transform: uppercase;
                        border-bottom: 1px solid #e2e8f0; background: #f8fafc;
                        white-space: nowrap; user-select: none;
                    }
                    .soc-th.sortable { cursor: pointer; }
                    .soc-th.sortable:hover { color: #3b82f6; background: #f0f7ff; }
                    .soc-tr { transition: background 0.15s; }
                    .soc-tr:hover td { background: #f8faff !important; }
                    .soc-td { padding: 10px 14px; font-size: 0.82rem; color: #334155; vertical-align: middle; }
                    .soc-link { color: #3b82f6; text-decoration: none; font-weight: 600; }
                    .soc-link:hover { text-decoration: underline; }
                    .btn-edit {
                        padding: 5px 10px; border: 1px solid #e2e8f0;
                        border-radius: 7px; background: white; cursor: pointer;
                        font-size: 0.75rem; color: #64748b; transition: all 0.15s;
                    }
                    .btn-edit:hover { border-color: #3b82f6; color: #3b82f6; background: #eff6ff; }
                    .btn-del {
                        padding: 5px 10px; border: 1px solid #fee2e2;
                        border-radius: 7px; background: white; cursor: pointer;
                        font-size: 0.75rem; color: #ef4444; transition: all 0.15s;
                    }
                    .btn-del:hover { background: #fef2f2; border-color: #ef4444; }
                    .page-btn {
                        min-width: 34px; height: 34px; padding: 0 10px;
                        border: 1px solid #e2e8f0; border-radius: 8px;
                        background: white; cursor: pointer; font-size: 0.82rem;
                        color: #475569; transition: all 0.15s; font-family: 'Inter', sans-serif;
                        display: flex; align-items: center; justify-content: center;
                    }
                    .page-btn:hover:not(:disabled) { border-color: #3b82f6; color: #3b82f6; }
                    .page-btn.active { background: #3b82f6; color: white; border-color: #3b82f6; font-weight: 700; }
                    .page-btn:disabled { opacity: 0.4; cursor: not-allowed; }
                    .cliente-chip {
                        display: inline-flex; align-items: center; gap: 5px;
                        background: #eff6ff; border: 1px solid #bfdbfe;
                        border-radius: 20px; padding: 3px 10px 3px 4px;
                        font-size: 0.75rem; color: #2563eb; margin: 2px;
                    }
                    .cliente-chip button {
                        background: #bfdbfe; border: none; border-radius: 50%;
                        width: 14px; height: 14px; cursor: pointer; font-size: 0.6rem;
                        color: #1d4ed8; padding: 0; display: flex; align-items: center; justify-content: center;
                    }
                    .cliente-chip button:hover { background: #ef4444; color: white; }
                    @keyframes fadeIn { from { opacity: 0; } to { opacity: 1; } }
                    .soc-table-wrap { animation: fadeIn 0.3s ease; }
                    @keyframes spin { to { transform: rotate(360deg); } }
                    .spinner { width: 36px; height: 36px; border: 3px solid #e2e8f0; border-top-color: #3b82f6; border-radius: 50%; animation: spin 0.7s linear infinite; }
                `}</style>

                <div className="soc-root" style={styles.inner}>

                    {/* Header */}
                    <div style={styles.pageHeader}>
                        <div>
                            <h1 style={styles.pageTitle}>Sociedades</h1>
                            <p style={styles.pageSubtitle}>{filtered.length} sociedad{filtered.length !== 1 ? 'es' : ''} encontrada{filtered.length !== 1 ? 's' : ''}</p>
                        </div>
                        <div style={{ display: 'flex', gap: 10, flexWrap: 'wrap', alignItems: 'center' }}>
                            <button className="btn-edit" onClick={() => this.descargarExcel(filtered)} style={{ padding: '8px 16px', fontSize: '0.82rem' }}>
                                📥 Exportar Excel
                            </button>
                            {AuthenticationService.haveAuthorization("WRITE_SOCIEDADES") && (
                                <button onClick={this.props.addElementClicked} style={styles.btnAdd}>
                                    + Nueva Sociedad
                                </button>
                            )}
                        </div>
                    </div>

                    {/* Filtros */}
                    <div style={styles.filtersCard}>

                        {/* Fila 1: Filtros de Sociedades */}
                        <div style={{ marginBottom: 4 }}>
                            <div style={{ fontSize: '0.68rem', fontWeight: 700, color: '#3b82f6', letterSpacing: '1px', textTransform: 'uppercase', marginBottom: 10, display: 'flex', alignItems: 'center', gap: 6 }}>
                                <span>🏢</span> Filtros de Sociedades
                            </div>
                            <div style={styles.filtersGrid}>
                                {/* Búsqueda */}
                                <div style={styles.filterGroup}>
                                    <label style={styles.filterLabel}>Buscar</label>
                                    <input
                                        className="soc-input"
                                        type="text"
                                        placeholder="Razón social, RFC..."
                                        value={busqueda}
                                        onChange={e => this.onBusqueda(e.target.value)}
                                    />
                                </div>

                                {/* Proyectos */}
                                <div style={styles.filterGroup}>
                                    <label style={styles.filterLabel}>Proyecto</label>
                                    <select className="soc-select"
                                        onChange={e => {
                                            const val = e.target.value
                                            if (!val) return
                                            const found = allClientes.find(c => String(c.id) === val)
                                            if (found && !clientes.find(c => c.id === found.id))
                                                this.setFilterState({ clientes: [...clientes, found], currentPage: 1 })
                                            e.target.value = ""
                                        }}>
                                        <option value="">Seleccionar proyecto...</option>
                                        {allClientes.map(c => <option key={c.id} value={c.id}>{c.nombreCliente}</option>)}
                                    </select>
                                    {clientes.length > 0 && (
                                        <div style={{ marginTop: 6, display: 'flex', flexWrap: 'wrap' }}>
                                            {clientes.map(c => (
                                                <span key={c.id} className="cliente-chip">
                                                    <button onClick={() => this.setFilterState({ clientes: clientes.filter(x => x.id !== c.id), currentPage: 1 })}>✕</button>
                                                    {c.nombreCliente}
                                                </span>
                                            ))}
                                        </div>
                                    )}
                                </div>

                                {/* Estatus Contable */}
                                <div style={styles.filterGroup}>
                                    <label style={styles.filterLabel}>Estatus Contable</label>
                                    <select className="soc-select" value={statusContable}
                                        onChange={e => this.setFilterState({ statusContable: e.target.value, currentPage: 1 })}>
                                        <option value="">Todos</option>
                                        {statusContableOpts.map(o => <option key={o} value={o}>{o}</option>)}
                                    </select>
                                </div>

                                {/* Estatus Legal */}
                                <div style={styles.filterGroup}>
                                    <label style={styles.filterLabel}>Estatus Legal</label>
                                    <select className="soc-select" value={statusLegal}
                                        onChange={e => this.setFilterState({ statusLegal: e.target.value, currentPage: 1 })}>
                                        <option value="">Todos</option>
                                        {statusLegalOpts.map(o => <option key={o} value={o}>{o}</option>)}
                                    </select>
                                </div>
                            </div>
                        </div>

                        {/* Separador */}
                        <div style={{ borderTop: '1px solid #e8edf5', margin: '14px 0' }} />

                        {/* Fila 2: Filtros de Domicilios */}
                        <div>
                            <div style={{ fontSize: '0.68rem', fontWeight: 700, color: '#10b981', letterSpacing: '1px', textTransform: 'uppercase', marginBottom: 10, display: 'flex', alignItems: 'center', gap: 6 }}>
                                <span>📍</span> Filtros de Domicilios
                            </div>
                            <div style={styles.filtersGrid}>
                                {/* Búsqueda por domicilio */}
                                <div style={styles.filterGroup}>
                                    <label style={styles.filterLabel}>Buscar Domicilio</label>
                                    <input
                                        className="soc-input"
                                        type="text"
                                        placeholder="Calle, colonia, municipio, CP..."
                                        value={busquedaDomicilio}
                                        onChange={e => this.setFilterState({ busquedaDomicilio: e.target.value.toUpperCase(), currentPage: 1 })}
                                    />
                                </div>

                                {/* Control domicilio */}
                                <div style={styles.filterGroup}>
                                    <label style={styles.filterLabel}>Control</label>
                                    <select className="soc-select" value={controlDom}
                                        onChange={e => this.setFilterState({ controlDom: e.target.value, currentPage: 1 })}>
                                        <option value="">Todos</option>
                                        <option value="CONTROL">Control</option>
                                        <option value="NO CONTROL">No Control</option>
                                    </select>
                                </div>

                                {/* Tipo domicilio */}
                                <div style={styles.filterGroup}>
                                    <label style={styles.filterLabel}>Tipo</label>
                                    <select className="soc-select" value={tipoDom}
                                        onChange={e => this.setFilterState({ tipoDom: e.target.value, currentPage: 1 })}>
                                        <option value="">Todos</option>
                                        <option value="FISICO">Físico</option>
                                        <option value="VIRTUAL">Virtual</option>
                                        <option value="DEL CLIENTE">Del Cliente</option>
                                    </select>
                                </div>
                            </div>
                        </div>

                        {/* Reset filtros */}
                        {hasFilters && (
                            <div style={{ paddingTop: 12, borderTop: '1px solid #f1f5f9', marginTop: 12 }}>
                                <button className="btn-edit" style={{ fontSize: '0.78rem' }}
                                    onClick={() => {
                                        clearFilters()
                                        this.setFilterState({ statusContable: '', statusLegal: '', clientes: [], busqueda: '', controlDom: '', tipoDom: '', busquedaDomicilio: '', currentPage: 1 }, () => {
                                            ElementsDataService.retrieveAllElements("sociedades")
                                                .then(r => this.setState({ elements: this.doSort(this.state.sortKey, this.state.sortAsc, r.data) }))
                                        })
                                    }}>
                                    ✕ Limpiar filtros
                                </button>
                            </div>
                        )}
                    </div>

                    {/* Loading */}
                    {loading && (
                        <div style={{ display: 'flex', justifyContent: 'center', padding: 60 }}>
                            <div className="spinner" />
                        </div>
                    )}

                    {/* Tabla */}
                    {!loading && (
                        <div style={styles.tableCard} className="soc-table-wrap">
                            <div style={{ overflowX: 'auto' }}>
                                <table style={{ width: '100%', borderCollapse: 'collapse' }}>
                                    <thead>
                                        <tr>
                                            <th className="soc-th" style={{ width: 40, textAlign: 'center' }}>#</th>
                                            <th className="soc-th sortable" onClick={() => this.sortBy('clientes')}>
                                                Proyecto <SortIcon k="clientes" />
                                            </th>
                                            <th className="soc-th sortable" onClick={() => this.sortBy('razonSocial')}>
                                                Razón Social <SortIcon k="razonSocial" />
                                            </th>
                                            <th className="soc-th sortable" onClick={() => this.sortBy('rfc')}>
                                                RFC <SortIcon k="rfc" />
                                            </th>
                                            <th className="soc-th sortable" onClick={() => this.sortBy('responsableContable')} style={{ whiteSpace: 'nowrap' }}>
                                                Resp. Cont. <SortIcon k="responsableContable" />
                                            </th>
                                            <th className="soc-th sortable" onClick={() => this.sortBy('auxiliarContable')} style={{ whiteSpace: 'nowrap' }}>
                                                Aux. Cont. <SortIcon k="auxiliarContable" />
                                            </th>
                                            <th className="soc-th" style={{ textAlign: 'center', whiteSpace: 'nowrap' }}>Est. Contable</th>
                                            <th className="soc-th" style={{ textAlign: 'center', whiteSpace: 'nowrap' }}>Est. Legal</th>
                                            <th className="soc-th">Domicilio Actual</th>
                                            <th className="soc-th" style={{ width: 40, textAlign: 'center' }}></th>
                                            {AuthenticationService.haveAuthorization("DELETE_SOCIEDADES") && <th className="soc-th" style={{ width: 40, textAlign: 'center' }}></th>}
                                        </tr>
                                    </thead>
                                    <tbody>
                                        {pageData.map((el, i) => {
                                            const n = (page - 1) * PAGE_SIZE + i + 1
                                            const isEven = i % 2 === 0
                                            return (
                                                <tr key={el.id} className="soc-tr" style={{ borderBottom: '2px solid #e2e8f0', background: isEven ? '#ffffff' : '#fafbfd' }}>
                                                    <td className="soc-td" style={{ color: '#94a3b8', fontWeight: 600, textAlign: 'center' }}>{n}</td>
                                                    <td className="soc-td">
                                                        {el.clientes?.map(c => (
                                                            <div key={c.id} style={{ fontSize: '0.78rem', color: '#64748b' }}>{c.nombreCliente}</div>
                                                        ))}
                                                    </td>
                                                    <td className="soc-td">
                                                        <Link to={`/sociedades/reportes/${el.id}`} className="soc-link">{el.razonSocial}</Link>
                                                    </td>
                                                    <td className="soc-td">
                                                        <Link to={`/sociedades/reportesContables/${el.rfc}`} className="soc-link" style={{ fontFamily: 'monospace', fontSize: '0.8rem' }}>{el.rfc}</Link>
                                                    </td>
                                                    <td className="soc-td" style={{ fontSize: '0.78rem' }}>{el.responsableContable || <span style={{ color: '#cbd5e1' }}>—</span>}</td>
                                                    <td className="soc-td" style={{ fontSize: '0.78rem' }}>{el.auxiliarContable || <span style={{ color: '#cbd5e1' }}>—</span>}</td>
                                                    <td className="soc-td" style={{ textAlign: 'center' }}>
                                                        {el.statusContabilidad ? (
                                                            <span style={{ ...styles.badge, ...getBadgeColor(el.statusContabilidad) }}>{el.statusContabilidad}</span>
                                                        ) : <span style={{ color: '#cbd5e1' }}>—</span>}
                                                    </td>
                                                    <td className="soc-td" style={{ textAlign: 'center' }}>
                                                        {el.statusLegal ? (
                                                            <span style={{ ...styles.badge, ...getBadgeColor(el.statusLegal?.toUpperCase()) }}>{el.statusLegal?.toUpperCase()}</span>
                                                        ) : <span style={{ color: '#cbd5e1' }}>—</span>}
                                                    </td>
                                                    <td className="soc-td" style={{ minWidth: 220 }}>
                                                        {(el.domicilios || []).length === 0
                                                            ? <span style={{ color: '#cbd5e1' }}>—</span>
                                                            : (el.domicilios || []).map((d, di) => (
                                                                <div key={di} style={{
                                                                    fontSize: '0.73rem',
                                                                    borderBottom: di < el.domicilios.length - 1 ? '1px dashed #e8edf5' : 'none',
                                                                    paddingBottom: di < el.domicilios.length - 1 ? 6 : 0,
                                                                    marginBottom: di < el.domicilios.length - 1 ? 6 : 0,
                                                                }}>
                                                                    <div style={{ fontWeight: 600, color: '#334155', marginBottom: 2 }}>
                                                                        {[d.calle, d.numeroExt].filter(Boolean).join(' ')}
                                                                        {d.colonia ? `, Col. ${d.colonia}` : ''}
                                                                    </div>
                                                                    {(d.municipio || d.estado) && (
                                                                        <div style={{ color: '#94a3b8', marginBottom: 3 }}>
                                                                            {[d.municipio, d.estado].filter(Boolean).join(', ')}
                                                                        </div>
                                                                    )}
                                                                    <div style={{ display: 'flex', gap: 4, flexWrap: 'wrap' }}>
                                                                        {d.control && (
                                                                            <span style={{
                                                                                fontSize: '0.65rem', padding: '1px 6px', borderRadius: 4, fontWeight: 600,
                                                                                background: d.control === 'CONTROL' ? '#eff6ff' : '#f8fafc',
                                                                                color: d.control === 'CONTROL' ? '#2563eb' : '#64748b',
                                                                                border: `1px solid ${d.control === 'CONTROL' ? '#bfdbfe' : '#e2e8f0'}`
                                                                            }}>
                                                                                {d.control}
                                                                            </span>
                                                                        )}
                                                                        {d.tipo && (
                                                                            <span style={{
                                                                                fontSize: '0.65rem', padding: '1px 6px', borderRadius: 4, fontWeight: 600,
                                                                                background: d.tipo === 'FISICO' ? '#f0fdf4' : d.tipo === 'VIRTUAL' ? '#faf5ff' : '#fff7ed',
                                                                                color: d.tipo === 'FISICO' ? '#16a34a' : d.tipo === 'VIRTUAL' ? '#7c3aed' : '#c2410c',
                                                                                border: `1px solid ${d.tipo === 'FISICO' ? '#bbf7d0' : d.tipo === 'VIRTUAL' ? '#e9d5ff' : '#fed7aa'}`
                                                                            }}>
                                                                                {d.tipo}
                                                                            </span>
                                                                        )}
                                                                    </div>
                                                                </div>
                                                            ))
                                                        }
                                                    </td>
                                                    <td className="soc-td" style={{ textAlign: 'center' }}>
                                                        <button className="btn-edit" onClick={() => this.props.updateElementClicked(el.id)}>✏️</button>
                                                    </td>
                                                    {AuthenticationService.haveAuthorization("DELETE_SOCIEDADES") && (
                                                        <td className="soc-td" style={{ textAlign: 'center' }}>
                                                            <button className="btn-del" onClick={() => this.props.deleteElementClicked(el.id)}>🗑</button>
                                                        </td>
                                                    )}
                                                </tr>
                                            )
                                        })}
                                        {pageData.length === 0 && (
                                            <tr>
                                                <td colSpan={11} style={{ textAlign: 'center', padding: '48px 0', color: '#94a3b8', fontSize: '0.85rem' }}>
                                                    Sin resultados con los filtros actuales
                                                </td>
                                            </tr>
                                        )}
                                    </tbody>
                                </table>
                            </div>

                            {/* Paginación */}
                            {totalPages > 1 && (
                                <div style={styles.pagination}>
                                    <span style={styles.pageInfo}>
                                        Mostrando {(page - 1) * PAGE_SIZE + 1}–{Math.min(page * PAGE_SIZE, filtered.length)} de {filtered.length}
                                    </span>
                                    <div style={{ display: 'flex', gap: 4, flexWrap: 'wrap' }}>
                                        <button className="page-btn" onClick={() => this.setFilterState({ currentPage: 1 })} disabled={page === 1}>«</button>
                                        <button className="page-btn" onClick={() => this.setFilterState({ currentPage: page - 1 })} disabled={page === 1}>‹</button>
                                        {getPageNumbers(page, totalPages).map((p, i) =>
                                            p === '...'
                                                ? <span key={i} style={{ padding: '0 4px', alignSelf: 'center', color: '#94a3b8' }}>…</span>
                                                : <button key={p} className={`page-btn${page === p ? ' active' : ''}`} onClick={() => this.setFilterState({ currentPage: p })}>{p}</button>
                                        )}
                                        <button className="page-btn" onClick={() => this.setFilterState({ currentPage: page + 1 })} disabled={page === totalPages}>›</button>
                                        <button className="page-btn" onClick={() => this.setFilterState({ currentPage: totalPages })} disabled={page === totalPages}>»</button>
                                    </div>
                                </div>
                            )}
                        </div>
                    )}
                </div>
            </div>
        )
    }
}

function getPageNumbers(current, total) {
    if (total <= 7) return Array.from({ length: total }, (_, i) => i + 1)
    if (current <= 4) return [1, 2, 3, 4, 5, '...', total]
    if (current >= total - 3) return [1, '...', total - 4, total - 3, total - 2, total - 1, total]
    return [1, '...', current - 1, current, current + 1, '...', total]
}

function getBadgeColor(status) {
    const s = (status || '').toUpperCase()
    if (s === 'ACTIVA') return { background: '#dcfce7', color: '#16a34a', borderColor: '#bbf7d0' }
    if (s === 'INACTIVA' || s === 'SUSPENDIDA' || s.includes('SUSP')) return { background: '#fef9c3', color: '#ca8a04', borderColor: '#fef08a' }
    if (s === 'LIQUIDADA' || s === 'LIQX') return { background: '#fee2e2', color: '#dc2626', borderColor: '#fecaca' }
    if (s === 'VENDIDA' || s === 'DEVUELTA') return { background: '#f3e8ff', color: '#9333ea', borderColor: '#e9d5ff' }
    return { background: '#f1f5f9', color: '#475569', borderColor: '#e2e8f0' }
}

const styles = {
    root: { minHeight: '100vh', background: '#f1f5f9', padding: '28px', fontFamily: "'Inter', sans-serif" },
    inner: { maxWidth: 1400, margin: '0 auto' },
    pageHeader: { display: 'flex', alignItems: 'flex-start', justifyContent: 'space-between', marginBottom: 24, flexWrap: 'wrap', gap: 12 },
    pageTitle: { margin: '0 0 4px', fontSize: '1.5rem', fontWeight: 700, color: '#0f172a' },
    pageSubtitle: { margin: 0, fontSize: '0.82rem', color: '#94a3b8' },
    btnAdd: { padding: '9px 18px', background: 'linear-gradient(135deg, #2563eb, #3b82f6)', border: 'none', borderRadius: 10, color: 'white', fontWeight: 600, fontSize: '0.85rem', cursor: 'pointer', boxShadow: '0 4px 12px rgba(59,130,246,0.3)', fontFamily: "'Inter', sans-serif" },
    filtersCard: { background: 'white', border: '1px solid #e8edf5', borderRadius: 16, padding: '20px 24px', marginBottom: 20, boxShadow: '0 2px 8px rgba(0,0,0,0.04)' },
    filtersGrid: { display: 'grid', gridTemplateColumns: 'repeat(auto-fill, minmax(200px, 1fr))', gap: 16 },
    filterGroup: { display: 'flex', flexDirection: 'column', gap: 6 },
    filterLabel: { fontSize: '0.68rem', fontWeight: 700, color: '#64748b', letterSpacing: '1px', textTransform: 'uppercase' },
    tableCard: { background: 'white', border: '1px solid #e8edf5', borderRadius: 16, overflow: 'hidden', boxShadow: '0 2px 8px rgba(0,0,0,0.04)' },
    badge: { fontSize: '0.7rem', fontWeight: 700, padding: '3px 10px', borderRadius: 20, border: '1px solid', letterSpacing: '0.5px', whiteSpace: 'nowrap' },
    pagination: { display: 'flex', alignItems: 'center', justifyContent: 'space-between', padding: '14px 20px', borderTop: '1px solid #f1f5f9', flexWrap: 'wrap', gap: 10 },
    pageInfo: { fontSize: '0.78rem', color: '#94a3b8' },
}

export default SociedadComponent
